module.exports = __webpack_public_path__ + "img/raise-query.eaead5e3.svg";